import { render, staticRenderFns } from "./nxshenhe.vue?vue&type=template&id=0d5985bb&scoped=true"
import script from "./nxshenhe.vue?vue&type=script&lang=js"
export * from "./nxshenhe.vue?vue&type=script&lang=js"
import style0 from "./nxshenhe.vue?vue&type=style&index=0&id=0d5985bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5985bb",
  null
  
)

export default component.exports